import { create } from 'zustand'
import { persist, createJSONStorage, PersistOptions } from 'zustand/middleware'

interface AgentState {
  agent: IAgentIdentity | null
  accessToken: string
  refreshToken: string
  impersonating: IImpersonationSession | null
  setSession: (agent: IAgentIdentity | null, accessToken: string, refreshToken: string) => void
  setTokens: (accessToken: string, refreshToken: string) => void
  setImpersonating: (impersonating: IImpersonationSession | null) => void
  clearAgent: () => void
}

/**
 * The agent's own identity and JWT, kept separate from auth.store because
 * auth.store.user is swapped out for the impersonated customer and cleared by
 * resetCustomerScopedState. This must survive both.
 */
export const useAgent = create(
  persist(
    (set) => ({
      agent: null,
      accessToken: '',
      refreshToken: '',
      impersonating: null,
      setSession: (agent, accessToken, refreshToken) => set({ agent, accessToken, refreshToken }),
      setTokens: (accessToken, refreshToken) => set({ accessToken, refreshToken }),
      setImpersonating: (impersonating) => set({ impersonating }),
      clearAgent: () => set({ agent: null, accessToken: '', refreshToken: '', impersonating: null }),
    }),
    {
      name: 'agent-storage',
      storage: createJSONStorage(() => localStorage),
    } as PersistOptions<AgentState, AgentState>
  )
)
